export function deepClone(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}

export function isValidEmail(email: string): boolean {
  const regexEmail = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
  return regexEmail.test(email);
}

export function validatePassword(value: string): boolean {
  if (!value) return true
  for (let i = 0; i < value.length - 2; i++) {
    const char1 = value.charCodeAt(i)
    const char2 = value.charCodeAt(i + 1)
    const char3 = value.charCodeAt(i + 2)
    // Verifica sequência numérica ou alfabética crescente (123, abc)
    if (char1 + 1 === char2 && char2 + 1 === char3) return false
    // Verifica sequência decrescente (321, cba)
    if (char1 - 1 === char2 && char2 - 1 === char3) return false
  }
  return true
}

export function isValidCNPJ(value: string): boolean {
  if (!value) return false
  if (value.length > 18) return false
  const digitsOnly = /^\d{14}$/.test(value)
  const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value)
  if (digitsOnly || validFormat) return true
  else return false

  const match = value.toString().match(/\d/g)
  const numbers = Array.isArray(match) ? match.map(Number) : []

  if (numbers.length !== 14) return false
  const items = [...new Set(numbers)]
  if (items.length === 1) return false

  const calc = (x) => {
    const slice = numbers.slice(0, x)
    let factor = x - 7
    let sum = 0
    for (let i = x; i >= 1; i--) {
      const n = slice[x - i]
      sum += n * factor--
      if (factor < 2) factor = 9
    }
    const result = 11 - (sum % 11)
    return result > 9 ? 0 : result
  }
  const digits = numbers.slice(12)
  const digit0 = calc(12)
  if (digit0 !== digits[0]) return false
  const digit1 = calc(13)
  return digit1 === digits[1]
}

export function isValidCPF(value: string): boolean {
  if (!value) return false
  const numbers = value.toString().match(/\d/g).map(Number)
  if (numbers.length !== 11) return false
  const items = [...new Set(numbers)]
  if (items.length === 1) return false
  const base = numbers.slice(0, 9)
  const digits = numbers.slice(9)
  const calc = (n, i, x) => n * (x - i)
  const sum = (r, n) => r + n
  const digit = (n) => {
    const rest = n % numbers.length
    return rest < 2 ? 0 : numbers.length - rest
  }
  const calc0 = base.map((n, i) => calc(n, i, numbers.length - 1)).reduce(sum, 0)
  const digit0 = digit(calc0)
  if (digit0 !== digits[0]) return false
  const calc1 = base
    .concat(digit0)
    .map((n, i) => calc(n, i, numbers.length))
    .reduce(sum, 0)
  const digit1 = digit(calc1)
  return digit1 === digits[1]
}

export function isValidCpfCnpj(value: string): boolean {
  if (!value) return false
  value = value.replaceAll(/[^0-9]/g, '');
  if (value.length > 11) return isValidCNPJ(value)
  return isValidCPF(value)
}

export function genUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16).replace("-", "");
  });
}

export function cepFormatter(cep: string): string {
  const cepcleared = String(cep).replace(/\D/g, '');
  if (cepcleared.length !== 8) return cepcleared;
  return cepcleared.replace(/^(\d{5})(\d{3})$/, '$1-$2');
}

export function toCpfCnpj(v: string): string {
  if (!v) return ''
  v = v.replace(/\D/g, '')
  if (v.length === 14) return cnpjFormatter(v)
  return cpfFormatter(v)
}

export function cnpjFormatter(v: string): string {
  if (v !== undefined && v !== null) {
    v = v.replace(/[^\d]/g, '')
    return v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  }
  return v
}

export function cpfFormatter(v: string): string {
  if (v !== undefined && v !== null) {
    v = v.replace(/[^\d]/g, '')
    return v.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }
  return v
}

export function capitalize(str: string): string {
  if (!str) return '';
  return str.split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export function moneyFormat(value: number | string, decimals: number = 2): string {
  const num = Number(value);
  if (isNaN(num)) return '0,00';
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
}

export function getRandomColor(size: number): string[] {
  const colors: string[] = [];
  const letters = '0123456789ABCDEF';
  while (colors.length < size) {
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    if (colors.includes(color)) continue;
    colors.push(color);
  }
  return colors;
}

export async function sleep(milis: number): Promise<any> {
  return new Promise(resolve => setTimeout(resolve, milis));
}

export function subtractYearsFromData(data: Date, anos:number) {
  const novaData = new Date(data);
  novaData.setFullYear(data.getFullYear() - anos);
  return novaData;
}

export function getText(text: string, ini: string, fim: string): string {
  try {
    text = '#' + text.trim() + '$'
    const posIni = text.indexOf(ini)
    if (posIni < 0) {
      return ''
    }
    const posFim = text.indexOf(fim, posIni + 1)
    text = text.substring(posIni + ini.length, posFim)
    return text.trim()
  } catch (e) {
    console.error(e)
  }
  return ''
}
